<!-- src/app/pages/endorsements/endorsements.component.html -->
<section class="endorsements-page">
  <div class="container">

    <!-- HERO -->
    <div class="hero">
      <h1>Endorsements</h1>
      <p class="hero-sub">
        Leaders and Michiganders who believe in an independent voice for our state.
      </p>
    </div>

    <!-- COMING SOON STATE -->
    <div *ngIf="!hasAny" class="coming-soon">
      <div class="coming-soon__icon">★</div>
      <h2>Endorsements Coming Soon</h2>
      <p>
        We're building a coalition of leaders, organizations, and everyday Michiganders
        who believe Michigan deserves representation without party strings attached.
      </p>
      <p>
        Want to endorse Lydia?
        <a routerLink="/contact">Get in touch.</a>
      </p>
    </div>

    <!-- ENDORSEMENT CATEGORIES -->
    <div *ngIf="hasAny" class="categories">
      <div *ngFor="let cat of filledCategories" class="category">
        <h2 class="category__heading">
          <span class="category__icon">{{ cat.icon }}</span>
          {{ cat.label }}
        </h2>
        <div class="endorsement-grid">
          <div *ngFor="let e of cat.endorsements" class="endorsement-card">
            <div *ngIf="e.photo" class="endorsement-card__photo">
              <img [src]="e.photo" [alt]="e.name" />
            </div>
            <div *ngIf="!e.photo" class="endorsement-card__avatar">
              {{ e.name.charAt(0) }}
            </div>
            <div class="endorsement-card__body">
              <div class="endorsement-card__name">{{ e.name }}</div>
              <div class="endorsement-card__title">{{ e.title }}</div>
              <blockquote *ngIf="e.quote" class="endorsement-card__quote">
                "{{ e.quote }}"
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <div class="endorse-cta">
      <h2>Add Your Endorsement</h2>
      <p>
        Community leaders, organizations, and individuals can endorse Lydia's campaign.
        Contact us to be listed here.
      </p>
      <a routerLink="/contact" class="btn-primary">Endorse Lydia</a>
    </div>

  </div>
</section>
